module.exports = __webpack_public_path__ + "img/LOGO1.6a5c8d55.png";